// Ledger Vuex

import state from './ledgerStates.js'
import * as getters from './ledgerGetters.js'
import * as mutations from './ledgerMutations.js'
import * as actions from './ledgerActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
